import { useEffect, useRef } from 'react';
import { createFooter, initDictionaryCatalog } from '@wg/wows-common-footer/main';
import { IFooterProps, Realm } from '@wg/wows-common-footer/types';

import { settings } from '~/helpers/utils';

import styles from './Footer.scss';

const Footer = () => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        async function initFooter() {
            await initDictionaryCatalog({ language: settings.languageCode, dictionaryCatalog: window.i18n.catalog });

            const options: IFooterProps = {
                selector: '#footer-container',
                language: settings.languageCode,
                realm: settings.realm as Realm,
                version: '',
                dictionaryCatalog: window.i18n.catalog,
                rootUrl: null,
                onLanguageChange: ({ realm, language }) => {
                    location.href = `${settings.realmsMap[realm]}/${language}/`;
                },
                onClickByLink: (event: MouseEvent) => {
                    event.preventDefault();
                    const target = event.currentTarget as HTMLLinkElement;
                    if (target.id !== 'ot-sdk-btn') {
                        window.open(target.href, '_blank');
                    }
                },
            };

            if (settings.realm === 'cn360') {
                options.realms = [];
            }

            createFooter(options);
        }

        initFooter();
    }, []);

    useEffect(() => {
        if (!(ref.current instanceof Element)) {
            return;
        }

        const observer = new MutationObserver(() => {
            const element = document.getElementById('ot-sdk-btn');
            if (element && window.OneTrust) {
                observer.disconnect();

                window.OneTrust?.initializeCookiePolicyHtml?.();
            }
        });

        observer.observe(ref.current, {
            childList: true,
            subtree: true,
        });

        return () => {
            observer.disconnect();
        };
    }, [ref]);

    return <div ref={ref} id={'footer-container'} className={styles.footer} />;
};

export default Footer;
